export default __webpack_public_path__ + "static/media/logo-OTP.799b301b.png";